import { Button, Heading } from "@RooUI";
import React from "react";

import { LicenseInformation } from "../../../Common/EditProfile/licenseInformation";
import { TechCredentials } from "../../../tech/profile/components/techEditProfileTabbed/TechExperience/TechCredentials";
import { FormContainer, FormFields, FormHeader } from "../Common/styles";
import { ButtonContainer } from "../RegistrationPageContainer/styles";

import { useFormContext } from "./RegistrationLicenseFormContext";
import { RegistrationTechLicenseFormText } from "./RegistrationTechLicenseFormText";
import { useIsLicenseRequired, useValidate } from "./service";

export const RegistrationTechLicenseForm = () => {
  const {
    onChange,
    onSave,
    loading,
    errors,
    // @ts-expect-error TS2339
    form: { licenses = [], deletedLicenses, isCertified, isLicensed, isVTS, isRegistered },
  } = useFormContext();
  const { hasLicense, hasPartialLicense } = useValidate();
  const isLicenseRequired = useIsLicenseRequired();
  const buttonText =
    hasLicense(licenses) ||
    hasPartialLicense(licenses) ||
    isLicenseRequired ||
    isCertified ||
    isLicensed ||
    isRegistered ||
    isVTS
      ? "Continue"
      : "Continue Without Adding";

  return (
    <FormContainer>
      <FormHeader>
        <Heading level={3}>Are you a licensed technician or an assistant?</Heading>
        <RegistrationTechLicenseFormText />
      </FormHeader>
      <FormFields>
        <TechCredentials useFormContext={useFormContext} hideCredentialStates flex />
        <LicenseInformation
          licenses={licenses}
          deletedLicenses={deletedLicenses}
          // @ts-expect-error TS2322
          onChange={onChange}
          hideExpiration
          hideHeader
          hideAddAnotherLicense
          hideClose
          // @ts-expect-error TS18048
          error={errors["licenses"]}
        />
      </FormFields>
      <ButtonContainer>
        <Button
          $buttonType="primary"
          title={buttonText}
          onClick={onSave}
          loading={loading}
          data-testid="licenseContinue"
        />
      </ButtonContainer>
    </FormContainer>
  );
};
